module.exports = __webpack_public_path__ + "epilace_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/epilace_1_after.jpg
// module id = 943
// module chunks = 0